import { render, staticRenderFns } from "./ListaOSCanceladas.vue?vue&type=template&id=7a4af6c6&"
import script from "./ListaOSCanceladas.vue?vue&type=script&lang=js&"
export * from "./ListaOSCanceladas.vue?vue&type=script&lang=js&"
import style0 from "./ListaOSCanceladas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports